import { DateTime } from "luxon";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import Text from "../../ui/Text";
import { selectAdvancedMode } from "../settings/slice";
import { calculateOrbitType } from "./orbit";

const AgeSince = ({ epoch, periapsis, apoapsis, period, referenceTime }) => {
	var dispText = epoch;
	var isCaution = false;
	var isWarning = false;
	const advancedMode = useSelector(selectAdvancedMode);
	if (!epoch) {
		return "-";
	}

	try {
		if (!advancedMode) {
			const t = DateTime.fromISO(epoch);

			let timePoint = null;
			if (referenceTime == null) {
				timePoint = DateTime.now();
			} else {
				timePoint = DateTime.fromISO(referenceTime);
			}

			const age = timePoint.diff(t, ["days", "hours"]);
			const ageDays = timePoint.diff(t).as("day");
			const orbitType = calculateOrbitType(periapsis, apoapsis, period);

			// TODO this seems different to the actually isCaution impl?
			// Too old: LEO/GEO - 24hrs - Warning
			//          MEO - 1 week - Bad
			// Older than 1 month: Bad

			dispText = age.toHuman().replace("hours", "hrs") + " old";
			isCaution =
				orbitType === "Medium Earth Orbit" ? ageDays > 2 : ageDays > 7;
			isWarning =
				orbitType === "Medium Earth Orbit" ? ageDays > 7 : ageDays > 31;
		}

		return (
			<Text
				small
				noWrap
				title={`TLE epoch: ${epoch}`}
				caution={isCaution}
				warning={isWarning}
			>
				{dispText}
			</Text>
		);
	} catch (_) {
		return (
			<Text small error>
				invalid epoch
			</Text>
		);
	}
};

AgeSince.propTypes = {
	// the datetime (epoch) of the TLE i.e. when it was orbiting in this way
	epoch: PropTypes.string,
	// optionally give a reference datetime in which case the age will be calculated
	// relative to this time ans not the default value of now
	referencePoint: PropTypes.string,
};

export default AgeSince;
